import React from 'react';
import ContactSection from '../Components/ContactSection';
import Snow from '../Components/Snow'

const People: React.FC = () => {
  return (
    <div>
      {/* <Snow/> */}
      <ContactSection/>
    </div>
  );
};

export default People;